module.exports = __webpack_public_path__ + "static/media/spinner.88f032b5.gif";